import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

import styles from "./replications.module.scss";
import { Pannel } from "../../../../primitives";

const ProjectReplications = ({ project }) => {
  const [showMore, setShowMore] = useState(false);
  const history = useHistory();

  const getOriginalProject = useMemo(() => {
    if (!project.original_project?.id) {
      return null
    }

    return (
      <div
        className="d-flex flex-row mb-3"
        onClick={() => history.push(`/projects/${project.original_project?.id}`)}
      >
        <div className="d-flex flex-column w-100">
          <div className="d-flex justify-content-between">
            <h5 className="text-bold mb-3">Original Project</h5>
            <span>Status</span>
          </div>
          <div className="d-flex flex-row">
            <span className={styles.number}>1.</span>
            <div className="d-flex flex-column w-100">
              <div className="d-flex align-items-center w-100 justify-content-between">
                <span className={styles.replicationItem}>{project.original_project?.name}</span>
                {
                  project.original_project?.plant && (
                    <Tooltip
                      title="Original Project"
                      placement="top"
                    >
                      <div className={styles.originalPlantCircle}></div>
                    </Tooltip>
                  )
                }
              </div>
              {
                project.original_project?.plant && (
                  <span className="text-muted small">{project.original_project?.plant?.name}</span>
                )
              }
            </div>
          </div>
        </div>
      </div>
    )
  }, [project])

  return (
    <Pannel title="Project Replications" padding="0">
      <div className={styles.panelHeader}>
        Replications
      </div>
      <div className={styles.wrapper}>
        {getOriginalProject}
        {
          project?.replications?.length > 0 ? (
            <>
              <div className="d-flex justify-content-between">
                <h5 className="text-bold mb-3">Replications</h5>
                <span>Status</span>
              </div>
              {
                project.replications
                  .slice(0, showMore ? project.replications.length : 5)
                  .map((r, idx) => (
                    <div
                      className="d-flex flex-row mb-2"
                      key={r.id}
                      onClick={() => history.push(`/projects/${r.id}`)}
                    >
                      <span className={styles.number}>{idx + (project.original_project?.id ? 2 : 1)}.</span>
                      <div className="d-flex flex-column w-100">
                        <div className="d-flex align-items-center w-100 justify-content-between">
                          <span className={styles.replicationItem}>{r.name}</span>
                          {
                            r.plant && (
                              <Tooltip
                                title="Replicated"
                                placement="top"
                              >
                                <div className={styles.plantCircle}></div>
                              </Tooltip>
                            )
                          }
                        </div>
                        {
                          r.plant && (
                            <span className="text-muted small">{r.plant?.name}</span>
                          )
                        }
                      </div>
                    </div>
                  ))
              }
            </>
          ) : null
        }
        {
          project?.replications?.length > 5 ? (
            <span
              className="small cursor-pointer"
              onClick={() => setShowMore(!showMore)}
            >{showMore ? "show less" : "show more"}</span>
          ) : null
        }
      </div>
    </Pannel>
  );
};

export default ProjectReplications;
